export default __webpack_public_path__ + "static/media/lgb-body-bold.54567e8d.jpg";